function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { Spin } from "antd";
import { isEmpty } from "lodash";
import mapboxgl from "mapbox-gl";
import React, { useEffect } from "react";
import styles from "./MapView.module.scss";
import { MapViewBloc } from "./MapViewBloc";
import { CanvasView } from "./views/CanvasView";
import { PreviewView } from "./views/PreviewView";
import { useDidMount } from "../../hooks/useDidMount";
export var initialMapSize = {
  width: 300,
  height: 600
};
export function MapView(props) {
  var id = props.id,
    bloc = props.bloc,
    isShare = props.isShare,
    textAreaValue = props.textAreaValue,
    resizeEventParams = props.resizeEventParams,
    noWheelClassName = props.noWheelClassName,
    errorText = props.errorText,
    isInBlueprint = props.isInBlueprint;
  var _ref = resizeEventParams || {},
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? initialMapSize.width : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? initialMapSize.height : _ref$height;
  // const isMobile = window.navigator.userAgent.includes("Mobile");

  useEffect(function () {
    if (bloc.map.value) {
      bloc.map.value.resize();
    }
  }, [width, height]);
  useEffect(function () {
    if (isEmpty(textAreaValue)) {
      return;
    }
    if (bloc.isFirstLoad.value) {
      return;
    }
    var inputTxt = typeof textAreaValue === "string" ? textAreaValue : textAreaValue === null || textAreaValue === void 0 ? void 0 : textAreaValue.value;
    bloc.reloadMap(inputTxt);
  }, [props.reloadMap, textAreaValue]);
  useDidMount(function () {
    // 如果是取消接口请求，不重新执行init
    if (errorText && errorText.includes("aborted")) return;
    var inputTxt = typeof textAreaValue === "string" ? textAreaValue : textAreaValue === null || textAreaValue === void 0 ? void 0 : textAreaValue.value;
    bloc.init(id, inputTxt);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.mapBoxInner,
    style: id.includes("preview") || isInBlueprint === true ? {} : {
      width: width,
      height: height,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(Spin, {
    tip: "Loading",
    size: "large",
    spinning: props.bloc.mapLoading.value
  }, id.includes("preview") || isShare ? /*#__PURE__*/React.createElement(PreviewView, {
    noWheelClassName: noWheelClassName,
    id: id,
    bloc: bloc,
    height: height
  }) : /*#__PURE__*/React.createElement(CanvasView, {
    noWheelClassName: noWheelClassName,
    id: id,
    bloc: bloc,
    height: height
  })));
}
export var Map = function Map(props) {
  return /*#__PURE__*/React.createElement(MapView, _extends({}, props, {
    bloc: new MapViewBloc(mapboxgl)
  }));
};